export default "__VITE_ASSET__0a36ec01__"